import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { ApiHelpers } from '@iot-platform/iot-platform-utils';
import {
  CommonApiListResponse,
  CommonApiRequest,
  CommonApiResponse,
  CommonCRUDService,
  CommonIndexedPagination,
  Environment
} from '@iot-platform/models/common';
import { Receiver } from '@iot-platform/models/oyan';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReceiversService implements CommonCRUDService<Receiver, CommonIndexedPagination> {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient: HttpClient = inject(HttpClient);

  getAll(request: CommonApiRequest): Observable<CommonApiResponse<Receiver, CommonIndexedPagination>> {
    return this.httpClient
      .get(`${this.environment.api.url}${this.environment.api.endpoints.receivers}`, { params: ApiHelpers.getHttpParams(request) })
      .pipe(map((response: CommonApiListResponse<Receiver>) => ApiHelpers.getHttpResponse<Receiver>(response)));
  }

  getById(id: string): Observable<Receiver> {
    return this.httpClient.get<Receiver>(`${this.environment.api.url}${this.environment.api.endpoints.receivers}/${id}`);
  }

  // TODO
  addOne(receiver: Receiver): Observable<Receiver> {
    return of(receiver);
  }

  // TODO
  updateOne(receiver: Receiver): Observable<Receiver> {
    return of(receiver);
  }

  // TODO
  deleteOne(receiver: Receiver): Observable<Receiver> {
    return of(receiver);
  }
}
